import { AuthGuard } from './shared/guards/auth.guard';
import { BulkSearchGuard } from './shared/guards/bulk-search.guard';
import { adminGuard } from './shared/guards/admin.guard';
import { guestGuard } from './shared/guards/guest.guard';
import { UrlMatcher, UrlSegment } from '@angular/router';
export const routes = [
  // Specific routes first (standalone - no layout)

  // Redirección profesional de la raíz a login
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full' as const,
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    canActivate: [guestGuard],
  },

  // Main app routes (with layout) - put after specific routes
  {
    path: '',
    loadComponent: () =>
      import('./layout/app-layout.component').then((m) => m.AppLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'busqueda-individual',
        loadComponent: () =>
          import('./pages/busqueda-individual/busqueda-individual.component').then(
            (m) => m.BusquedaIndividualComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'busqueda-individual/historial',
        loadComponent: () =>
          import('./pages/busqueda-individual/historial-busqueda-individual/historial-busqueda-individual').then(
            (m) => m.HistorialBusquedaIndividual,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'busqueda-masiva',
        loadComponent: () =>
          import('./pages/busqueda-masiva/busqueda-masiva.component').then(
            (m) => m.BusquedaMasivaComponent,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
        data: { requiresAuth: true },
      },
      {
        path: 'busqueda-masiva/primera-busqueda',
        loadComponent: () =>
          import('./pages/busqueda-masiva/primera-busqueda/primera-busqueda').then(
            (m) => m.PrimeraBusquedaComponent,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
        data: { requiresAuth: true },
      },
      {
        path: 'busqueda-masiva/historial',
        loadComponent: () =>
          import('./pages/busqueda-masiva/historial-busqueda-masiva/historial-busqueda-masiva').then(
            (m) => m.HistorialBusquedaMasiva,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
        data: { requiresAuth: true },
      },
      {
        path: 'monitoreo',
        loadComponent: () =>
          import('./pages/monitoreo/monitoreo.component').then(
            (m) => m.MonitoreoComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'notificaciones',
        loadComponent: () =>
          import('./pages/notificaciones/notificaciones.component').then(
            (m) => m.NotificacionesComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'cuenta',
        loadComponent: () =>
          import('./pages/cuenta/cuenta.component').then(
            (m) => m.CuentaComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./pages/usuarios/usuarios.component').then(
            (m) => m.UsuariosComponent,
          ),
        canActivate: [AuthGuard, adminGuard],
      },
      {
        path: 'agregar-usuario',
        loadComponent: () =>
          import('./shared/components/agregar-usuario/agregar-usuario.component').then(
            (m) => m.AgregarUsuarioComponent,
          ),
        canActivate: [AuthGuard, adminGuard],
      },
      {
        path: 'centro-soporte',
        redirectTo: 'https://riskyid.com/soporte/',
      },
      {
        path: 'busqueda-masiva/resultado-lista-coincidencia',
        loadComponent: () =>
          import('./pages/busqueda-masiva/resultado-lista-coincidencia/resultado-lista-coincidencia.component').then(
            (m) => m.ResultadoListaCoincidenciaComponent,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
      },
      {
        path: 'busqueda-masiva/resultados',
        loadComponent: () =>
          import('./pages/busqueda-masiva/resultados/resultados.component').then(
            (m) => m.ResultadosComponent,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
      },
      {
        path: 'busqueda-masiva/perfiles-no-procesados',
        loadComponent: () =>
          import('./pages/busqueda-masiva/perfiles-no-procesados/perfiles-no-procesados.component').then(
            (m) => m.PerfilesNoProcesadosComponent,
          ),
        canActivate: [AuthGuard, BulkSearchGuard],
      },
    ],
  },

  // UUID Short Link Route - Must be before wildcard
  // UUID Clean Link Route - Must be before wildcard
  {
    matcher: (url: UrlSegment[]) => {
      // Check if there's exactly one segment and it matches UUID format
      if (url.length === 1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(url[0].path)) {
        return { consumed: url, posParams: { uuid: url[0] } };
      }
      return null;
    },
    loadComponent: () => import('./layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/busqueda-individual/historial-busqueda-individual/historial-busqueda-individual').then(m => m.HistorialBusquedaIndividual)
      }
    ]
  },

  // Wildcard route - MUST be last
  {
    path: '**',
    redirectTo: '/login',
  },
];
